/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { ZodType, z } from 'zod';

import {
  endpointModelSchema,
  finetuningModelSchema,
} from '@fai/friendli-suite/features/products/dedicated-endpoints/form-context';
import { DedicatedModelType } from '@fai/friendli-suite/features/types/dedicated-endpoints/models';

const modelRefiner: Parameters<
  ZodType<z.infer<typeof endpointModelSchema> | z.infer<typeof finetuningModelSchema>>['refine']
>[0] = (schema) => {
  switch (schema.type) {
    case DedicatedModelType.HuggingFace: {
      return z
        .object({
          repositoryName: z.string().min(1),
          repositoryRevision: z.string().nullable(),
        })
        .safeParse(schema.huggingFace).success;
    }
    case DedicatedModelType.Wandb: {
      return z.object({ artifactName: z.string().min(1) }).safeParse(schema.wandb).success;
    }
    case DedicatedModelType.Native: {
      return z.object({ modelId: z.string().min(1) }).safeParse(schema.native).success;
    }

    default: {
      return false;
    }
  }
};

export const refinedEndpointModelSchema = endpointModelSchema.refine(modelRefiner, {
  message: 'Model should be selected.',
});

export const refinedFinetuningModelSchema = finetuningModelSchema.refine(modelRefiner, {
  message: 'Model should be selected.',
});

export const refinedFinetuningDatasetSchema = finetuningModelSchema.refine(modelRefiner, {
  message: 'Dataset should be selected.',
});
